import { Layout } from "antd";
import Logo from "assets/images/logo.png";
import LogoLight from "assets/images/logo-light.png";
import dayjs from "dayjs";

const { Footer } = Layout;

const PublicFooter = ({ inverse }) => {
  return (
    <Footer className={`p-3 ${inverse ? "bg-primary dark:bg-dark1" : ""}`}>
      <div className="flex flex-col gap-1 items-center">
        <span className={inverse ? "text-white" : "text-gray-500"}>
          Powered By
        </span>
        <a
          href="https://gajihub.com/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-link-primary"
        >
          <img width={70} src={inverse ? LogoLight : Logo} alt="Logo" />
        </a>
        <span className={inverse ? "text-gray-200" : "text-gray-500"}>
          &copy;{` ${dayjs().format("YYYY")} GajiHub. All rights reserved.`}
        </span>
      </div>
    </Footer>
  );
};

export default PublicFooter;
